import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { DiscoveredMcpTool } from "@/shared/domain/mcp/McpServerRecord";

interface DiscoverToolsArgs {
  serverId: string;
  orgId: string;
}

export function useAdminDiscoverTools() {
  const { mcpRegistryService } = useDomainServices();

  return useMutation<DiscoveredMcpTool[], Error, DiscoverToolsArgs>({
    mutationFn: ({ serverId, orgId }: DiscoverToolsArgs) =>
      mcpRegistryService.adminDiscoverTools(serverId, orgId),
  });
}
